import { Link, useOutletContext, useParams } from "react-router-dom";
import { Reveal, useSeo } from "@/components/site/Motion";
import { information } from "@/content/site";

export default function Information() {
  const { journal } = useOutletContext();
  const { type } = useParams();
  const info = information[type] || information.readers;
  useSeo(`${info.title} · ${journal.title}`, info.body);
  return (
    <Reveal data-testid={`information-${type}`}>
      <p className="eyebrow mb-5">Information</p>
      <h1 className="font-display text-5xl sm:text-6xl leading-[1.02] mb-10">{info.title}</h1>
      <p className="font-display text-2xl sm:text-3xl leading-snug max-w-3xl">{info.body}</p>
      <div className="mt-12 flex flex-wrap gap-4">
        <Link to={`/index.php/${journal.slug}/about`} className="inline-flex items-center h-12 px-6 rounded-full border border-[var(--ink)] hover:bg-[var(--ink)] hover:text-[var(--paper)] transition-colors" data-testid="info-about-link">About the Journal</Link>
        <Link to="/register" className="inline-flex items-center h-12 px-6 rounded-full bg-[var(--emerald)] text-[var(--paper)] hover:bg-[var(--emerald-2)] transition-colors" data-testid="info-register-link">Register</Link>
      </div>
    </Reveal>
  );
}
